import { render, staticRenderFns } from "./SubelementShow.vue?vue&type=template&id=17a8117b"
import script from "./SubelementShow.vue?vue&type=script&lang=ts"
export * from "./SubelementShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports